import React, { useEffect, useState } from 'react';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import BootstrapTable from 'react-bootstrap-table-next';
import Spinner from 'react-bootstrap/Spinner';
import { Col, Row } from 'react-bootstrap';
import * as apiUtility from "../../config/APIUtils";
import { IconButton, Paper, Tooltip, Box, Typography, Button } from "@mui/material";
import * as XLSX from "xlsx";
import * as XlsxPopulate from "xlsx-populate/browser/xlsx-populate";
import ErrorPopUp from '../Utility/ErrorPopUp';
import { RiFileExcel2Line } from "react-icons/ri";

function AdminHomeCourse(props) {
    const [adminHomeCrsData, setadminHomeCrsData] = useState([]);
    const [showSpinner, setshowSpinner] = useState(false);
    const [showErrorPopup, setShowErrorPopup] = useState(false);
    const [dataForErrorPopup, setDataForErrorPopup] = useState('');

    const fetchAdminHomeCrs = async (homeId = props.homeId) => {
        if (homeId === undefined || homeId === null) {
            setadminHomeCrsData([]);
            return;
        }
        setshowSpinner(true);
        try {
            const apiRequest = apiUtility.apiInputRequest;
            apiRequest.endPoint = "admin-data/home-crs-role/" + homeId;
            const res = await apiUtility.fetchAsyncAPIDataGET(apiRequest);
            var finalArr = [];
            var len = Array.isArray(res.data) ? res.data.length:0;
                for(var i=0;i<len;i++){
                    if(props.crsPolicyType && props.crsPolicyType=='9' || props.crsPolicyType=='11'){
                    if(res.data[i]['type'] === 'C'){
                       // console.log("Course Data:",res.data[i]);
                        res.data[i].type = 'Course';
                    finalArr.push(res.data[i]);
                    }
                    }
                    
                    if(props.crsPolicyType && props.crsPolicyType=='10' || props.crsPolicyType=='11'){
                        if(res.data[i]['type'] === 'P'){
                            res.data[i].type = 'Home Doc';
                    finalArr.push(res.data[i]);
                    }
                    }
                    
                }
            setadminHomeCrsData(finalArr);
        } catch (error) {
            console.error("Error fetching admin home course-role data:", error);
            setDataForErrorPopup("Unable to fetch home course-role data. Please try again.");
            setShowErrorPopup(true);
            setadminHomeCrsData([]);
        } finally {
            setshowSpinner(false);
        }
    };

    useEffect(() => {
        let mounted = true;
        if (props.homeId !== undefined && props.homeId !== null && mounted) {
            fetchAdminHomeCrs(props.homeId);
        } else {
            setadminHomeCrsData([]);
        }
        return () => { mounted = false; };
    }, [props.homeId]);

    var adminHomeCrsCols = [
        {
            dataField: 'role_id',
            sort: true,
            text: 'Role ID'
        },
        {
            dataField: 'role_name',
            sort: true,
            text: 'Role Name'
        },
        {
            dataField: 'type',
            sort: true,
            text: 'Course/Home Doc'
        },
        {
            dataField: 'id_arr',
            text: 'Course IDs/Home Doc Codes'
        },
        {
            dataField: 'archived',
            sort: true,
            text: 'Is Archived?'
        }
    ];

    const workbook2blob = (workbook) => {
        const wopts = {
            bookType: "xlsx",
            bookSST: false,
            type: "binary",
        };
        const wbout = XLSX.write(workbook, wopts);
        const blob = new Blob([s2ab(wbout)], {
            type: "application/octet-stream",
        });
        return blob;
    };
    const s2ab = (s) => {
        const buf = new ArrayBuffer(s.length);
        const view = new Uint8Array(buf);
        for (let i = 0; i !== s.length; i++) {
            view[i] = s.charCodeAt(i);
        }
        return buf;
    }

    //Excel
    const exportInExcel = async () => {
        try {
            var rowsCount = 6;
            const title = [{A: 'CarePassport - Course Role Report for Home ID : '+String(props.homeId)}];
            let reportView = [{ A:'Name',B:'User ID',C:'Role',D:'Date'}];
            reportView.push({
                A: sessionStorage.getItem('fullName'),
                B: sessionStorage.getItem('userId'),
                C: (sessionStorage.getItem('userType') !== null)?sessionStorage.getItem('userType').toUpperCase():"User",
                D: new Date().toLocaleString()
            });
            reportView.push("");
            reportView.push("");
            let reportHeaders = {A:'Role ID',B:'Role Name',C:'Course/Home Doc',D:'Course IDs/Home Doc Codes',E:'Archived?'};
            reportView.push(reportHeaders);
            adminHomeCrsData.forEach(element => {
                rowsCount += 1;
                var tempObj = {
                    A: element.role_id,
                    B: element.role_name,
                    C: element.type,
                    D: element.id_arr,
                    E: element.archived
                };
                reportView.push(tempObj);
            });
            const finalData = [...title, ...reportView];
            const worksheet = XLSX.utils.json_to_sheet(finalData, {
                skipHeader: true,
            });
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Home Course Role Report");
            const workbookblob = workbook2blob(workbook);
            var headerIndexes = [];
            finalData.forEach((data, index) =>
                data["A"] === "Role ID" ? headerIndexes.push(index) : null
            );
            const dataInfo = {
                titleCell: "A2",
                titleRange: "A1:E1",
                tbodyRange: `A7:D${finalData.length}`,
                uHeadRange: `A2:D2`,
                uBodyRange: `A3:D3`,
                theadRange:
                  headerIndexes?.length >= 1
                    ? `A${headerIndexes[0] + 1}:D${headerIndexes[0] + 1}`
                    : null,
                theadRange1:
                  headerIndexes?.length >= 2
                    ? `A${headerIndexes[1] + 1}:I${headerIndexes[1] + 1}`
                    : null,
                tFirstColumnRange:
                  headerIndexes?.length >= 1
                    ? `A${headerIndexes[0] + 1}:A${rowsCount + headerIndexes[0] + 1}`
                    : null,
                tLastColumnRange:
                  headerIndexes?.length >= 1
                    ? `K${headerIndexes[0] + 1}:I${rowsCount + headerIndexes[0] + 1}`
                    : null,
                tFirstColumnRange1:
                  headerIndexes?.length >= 1
                    ? `A${headerIndexes[1] + 1}:A${rowsCount + headerIndexes[1] + 1}`
                    : null,
                tLastColumnRange1:
                  headerIndexes?.length >= 1
                    ? `H${headerIndexes[0] + 1}:I${rowsCount + headerIndexes[1] + 1}`
                    : null,
              };
            XlsxPopulate.fromDataAsync(workbookblob).then((workbook)=>{
                workbook.sheets().forEach((sheet)=>{
                    sheet.column("A").width(15);
                    sheet.column("B").width(30);
                    sheet.column("C").width(15);
                    sheet.column("D").width(50);
                    sheet.column("E").width(15);
                    sheet.range(dataInfo.titleRange).merged(true).style({
                        bold: true,
                        fontFamily:"Arial",
                        horizontalAlignment: "center",
                        verticalAlignment: "center",
                    });
                    sheet.range(dataInfo.uHeadRange).style({
                        fill: "A6A6A6",
                        bold: true,
                        horizontalAlignment: "center",
                    });
                    sheet.range(dataInfo.uBodyRange).style({
                        bold: true,
                        horizontalAlignment: "center",
                    });
                    if (dataInfo.tbodyRange) {
                        sheet.range(dataInfo.tbodyRange).style({
                          horizontalAlignment: "left",
                        });
                      }
                      if (dataInfo.theadRange) {
                        sheet.range(dataInfo.theadRange).style({
                          fill: "A6A6A6",
                          bold: true,
                          horizontalAlignment: "center",
                        });
                      }
                      if (dataInfo.tFirstColumnRange) {
                        sheet.range(dataInfo.tFirstColumnRange).style({
                          bold: true,
                        });
                      }
                });

                return workbook.outputAsync().then((workbookBlob) => { 
                        const downloadAnchorNode = document.createElement("a");
                        var dateVar = new Date();
                        var fileName = "Carepassport_HomeCourseRoleReport-"+dateVar.getDate()+dateVar.getMonth()+dateVar.getFullYear()+"_"+dateVar.getHours()+dateVar.getMinutes()+".xlsx";
                        downloadAnchorNode.setAttribute("href", URL.createObjectURL(workbookBlob));
                        downloadAnchorNode.setAttribute("download", fileName);
                        downloadAnchorNode.click();
                        downloadAnchorNode.remove();
                });  
            });
        } catch (error) {
             setDataForErrorPopup("Something went wrong while processing excel!");
             setShowErrorPopup(true);
        }
    }

    return (
        <div>
            {showSpinner && (
                <div style={{ position: "fixed", inset: 0, display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999, background: "rgba(255,255,255,0.5)" }}>
                    <Spinner animation="border" size="lg" variant='primary' />
                </div>
            )}
            <Paper sx={{ p: 1, borderRadius: "1.5px" }}>
                {(!showSpinner && adminHomeCrsData.length === 0) ? (
                    <Box sx={{ p: 6, textAlign: "center" }}>
                        <Typography variant="h6" gutterBottom>No data available</Typography>
                        <Typography variant="body2" color="text.secondary" gutterBottom>
                            There are no course-role records for the selected home.
                        </Typography>
                        <Button variant="outlined" onClick={() => fetchAdminHomeCrs(props.homeId)}>Retry</Button>
                    </Box>
                ) : (
                    <BootstrapTable id='organizationStaffSpecificTable' keyField='id' data={adminHomeCrsData} columns={adminHomeCrsCols} striped hover />
                )}
                <Row>
                    <Col xs={0} md={8}></Col>
                    <Col xs={12} md={4} className="text-center">
                    <Paper component="form" variant="outlined"
                        sx={{float:"right", display: 'flex', marginBottom:"4px",alignItems: 'center', width: 50 }}
                        >
                        <Tooltip variant="contained" title="Export to Excel" disableRipple>
                            <IconButton color="primary" onClick={exportInExcel} sx={{ p: '10px' }} aria-label="directions">
                                <RiFileExcel2Line/>
                            </IconButton>
                        </Tooltip>   
                        </Paper>
                    </Col>
                </Row>
            </Paper>
            <ErrorPopUp show={showErrorPopup} data={dataForErrorPopup} onHide={() => { setShowErrorPopup(false) }} />
        </div>
    );
}

export default AdminHomeCourse;